<template>
  <div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_on_details_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Business Verification Form"
      id="owner_view_business_verify_form"
    ></CardedSectionHeader>
    <CardedDisplay>
      <PlainDisplay icon="mdi-eye" :show_icon="false" :title="''" cmp_class="">
        <v-icon>mdi-hash</v-icon>
        Your current verification status is:
        <b>{{ verification_status[parseInt(business.is_verified)] }}</b>
        <v-avatar color="grey" size="50" class="ml-5">
          <v-img
            :src="verification_src[parseInt(business.is_verified)]"
            alt="Verification Stamp"
          />
        </v-avatar>

        <br /><br />
        To verify your business please upload the following scanned images for these documents:
      </PlainDisplay>
    </CardedDisplay>
    <div class="white">
      <CardedForm
        ref="edit_verification_doc_form_ref"
        id="edit_verification_doc_form"
        title="_"
        :is_loading="is_loading"
        @on-submit-form="submit"
        :errors="errors"
        :message="message"
        @on-auto-fill="on_auto_fill"
        @on-close-message="on_hide_message"
        cmp_class="ma-0 pl-5 pr-5 pt-0 "
        :show_submit_btns_row="false"
      >
        <ImageField
            label="Business Scanned Document"
            icon="mdi-camera-x"
            :disabled="false"
            folder="businesslogoes"
            @on-hide-loader="hide_loader"
            @on-show-loader="show_loader"
            @on-success="on_finished_file_upload"
            @on-error="on_file_upload_errors"
            ref="edit_verification_document_uploader"
            :required="false"
            empty_file_error="No File Selected"
            :default_value="''"
            cmp_class='hgt-0-wdth-0'
            @on-change="send_file"
          >
          </ImageField>
        <CardedTable
          :items="items"
          :headers="headers"
          :show_search="false"
          :height="350"
          :show_footer="false"
          :show_header_bar="false"
          :has_margin="false"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              :class="'round-4 '"
              rounded
              filled
              ripple
              small
              color="primary"
              :disabled="is_loading"
              @click="update_verification_document(item)"
            >
              Upload Scanned Image
            </v-btn>
          </template>
        </CardedTable>
      </CardedForm>

      <v-alert dense text type="info" class="ma-0 mr-8 ml-10">
        We shall send you
        <strong> a confirmation sms and email </strong> after looking through
        the documents and confirming your ownership and existence of this
        business
      </v-alert>
      <br />
    </div>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import CardedDisplay from "../../../components/CardedDisplay";
import PlainDisplay from "../../../components/PlainDisplay";
import CardedTable from "../../../components/CardedTable";
import ImageField from "../../../components/ImageField";
export default {
  name: "OwnerBusinessesVerify",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedForm,
    CardedDisplay,
    PlainDisplay,
    CardedTable,
    ImageField
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      business: Utils.get_default_business(),
      is_owner: false,
      _user: null,
      errors: [],
      message: "",
      selected_document_item: null,
      uploaded_file_url: "",
      verification_src: {
        0: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1607508894/botswana%20services/website%20assets/verification_missing_rrfc7y.png",
        1: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1607508093/botswana%20services/website%20assets/verification_pending_cp3bln.png",
        2: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1607507535/botswana%20services/website%20assets/verified_stamp_xqikbc.jpg",
      },
      verification_status: {
        0: "not verified",
        1: "pending",
        2: "verified",
      },
      headers: [
        {
          text: "Document Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "Status",
          align: "start",
          sortable: false,
          value: "status",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  methods: {
    on_auto_fill(){
      this.init_form();
    },
    init_form() {
      this.selected_document_item = null;
      this.uploaded_file_url = "";
      this.errors = [];
      this.message = "";
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            this.init_form();
            //nyd
            //if they are not the owner
            //show them a message of not authorised
            //then redirect them to the login screen
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.edit_verification_doc_form_ref.show_error_dialog();
        }
      );
    },
    is_uploaded(key) {
      if (this.business && this.business[key]) {
        var link = this.business[key];
        if (link == null) {
          return false;
        }
        link = link.trim();
        if (link.length > 0) {
          return true;
        }
        return false;
      }
      return false;
    },
    update_verification_document(item) {
      //console.log("This is what happened : man ", item, this.$refs.edit_verification_document_uploader);
      this.selected_document_item = item;
      this.$refs.edit_verification_document_uploader.click_file_upload_input();
    },
    send_file(){
      this.$refs.edit_verification_document_uploader.upload_file();
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    on_finished_file_upload(file_url) {
      this.uploaded_file_url = file_url;
      this.submit();
    },
    on_file_upload_errors(errors) {
      this.errors = errors;
      this.$refs.edit_verification_doc_form_ref.show_error_dialog();
    },
    submit(){
      this.errors = [];
      this.message = "";
      var data = {};
      data[this.selected_document_item.id] = uploaded_file_url;
      ServerClient.Businesses.update_business_verifications(
        {
          data: data,
          id: this.business_id
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.$refs.edit_verification_doc_form_ref.on_clear_form();
          this.message =
            "<b>Operation was successfull</b> <br/>  File was uploaded successfully";
          this.$refs.edit_verification_doc_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.edit_verification_doc_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_hide_message(){
      this.load_business(this.business_id);
    }
  },
  computed: {
    items() {
      var list = [
        {
          id: "doc_idcopy_url",
          name: "YOUR NATIONAL ID or PASSPORT",
          status: this.is_uploaded("doc_idcopy_url")
            ? "uploaded"
            : "not yet provided",
        },
        {
          id: "doc_cert_incoporation_url",
          name: "CERTIFICATE of INCOPORATION",
          status: this.is_uploaded("doc_cert_incoporation_url")
            ? "uploaded"
            : "not yet provided",
        },
        {
          id: "doc_extr_comp_document_url",
          name: "COMPANY EXTRACT",
          status: this.is_uploaded("doc_extr_comp_document_url")
            ? "uploaded"
            : "not yet provided",
        },
        {
          id: "doc_cert_tax_url",
          name: "TAX CERTIFICATE",
          status: this.is_uploaded("doc_cert_tax_url")
            ? "uploaded"
            : "not yet provided",
        },
        {
          id: "doc_trade_liscence_url",
          name: "TARDE LISCENCE",
          status: this.is_uploaded("doc_trade_liscence_url")
            ? "uploaded"
            : "not yet provided",
        },
        {
          id: "doc_registration_cert_url",
          name: "REGISTRATION CERTIFICATE",
          status: this.is_uploaded("doc_registration_cert_url")
            ? "uploaded"
            : "not yet provided",
        },
      ];
      return list;
    },
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Business Verification",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/businesses/list/view/" + this.business_id,
        },
        {
          text: "Verify",
          disabled: true,
          href: "/owner/businesses/list/view/" + this.business_id + "/verify",
        },
      ],
      navbar_cols: 3,
    });
    this.load_business(this.business_id);

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_view_business_verify_form", options);
  },
};
</script>